import { AxiosResponseHeaders } from 'axios';
import { ExchangeCalculateResponseDTO } from '../entities';

const exchangeCalculateDTOToExchangeCalculateAdapter = (
  data: ExchangeCalculateResponseDTO,
  headers?: AxiosResponseHeaders,
) => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { exchangeCalculateDTOToExchangeCalculateAdapter };
